import type { KgInspectorDataGridColumn } from "../KgInspectorDataGrid";
import type { KgInspectorArtifactActivityRow } from "../../kg/canvas/inspector/types";

/** Activity tab grid — feed `events[]` from API via `KgInspectorArtifactActivityView`. */
export const ARTIFACT_ACTIVITY_GRID_COLUMNS: Array<
  KgInspectorDataGridColumn<KgInspectorArtifactActivityRow>
> = [
  {
    key: "type",
    header: "TYPE",
    width: "equal",
    render: (row) => row.type,
  },
  {
    key: "timestamp",
    header: "TIMESTAMP",
    width: "equal",
    render: (row) => row.timestamp,
  },
  {
    key: "published",
    header: "PUBLISHED",
    width: "equal",
    render: (row) => row.published,
  },
];

export const ARTIFACT_ACTIVITY_EMPTY_HINT =
  "No activity for this artifact yet.";
